module.exports = __webpack_public_path__ + "img/iframe.1a7a1b99.png";